export interface IEditarArea {
  areaId: string;
  nombre: string;
}

export const InitialEditarArear: IEditarArea = {
  areaId: "",
  nombre: "",
};

export interface ICrearArea {
  nombre: string;
}

export const InitialCrearArea: ICrearArea = {
  nombre: "",
};
